<template>
    <div class="row">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Row"
    }
</script>

<style lang="scss" scoped>

</style>
